import {
  AfterViewInit,
  Component,
  ElementRef, Input,
  OnChanges,
  OnInit,
  Renderer2,
  SimpleChanges,
  ViewChild
} from '@angular/core';

@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrl: './carousel.component.scss'
})
export class CarouselComponent implements OnInit, AfterViewInit {
  @Input() images: string[] =[]
  selectedIndex = 0;
  ngAfterViewInit(): void {
  }

  ngOnInit(): void {
  }

  next() {
    if (this.selectedIndex + 1 < this.images.length) {
      this.selectedIndex++;
    }
  }
  previous() {
    if (this.selectedIndex !== 0) {
      this.selectedIndex--;
    }
  }
}
